import { BreadcrumbsStateType, } from '@kubit/web-ui-components/breadcrumbs/types';
import { commonStyles } from '../commonStyles';
import { BreadcrumbsVariantType } from '../variants';
export const getRegularStyles = (FOUNDATIONS, FONT) => ({
    [BreadcrumbsVariantType.REGULAR]: {
        [BreadcrumbsStateType.DEFAULT]: {
            ...commonStyles(FOUNDATIONS, FONT),
        },
        [BreadcrumbsStateType.ACTIVE]: {
            ...commonStyles(FOUNDATIONS, FONT),
        },
        [BreadcrumbsStateType.HOVER]: {
            ...commonStyles(FOUNDATIONS, FONT),
            link: {
                ...commonStyles(FOUNDATIONS, FONT).link,
                color: FOUNDATIONS.color_accent_default_secondary_font_100,
                text_decoration: undefined,
            },
        },
    },
});
//# sourceMappingURL=regular.js.map